<template>
  <Tabs class="zpa-column zpa-tabs" :style="{'height': height + 'px'}" :animated="false">
    <TabPane v-for="(tab, index) in tabData" :key="index" :label="tab.name" :disabled="tab.disabled">
      <slot :name="tab.component"></slot>
    </TabPane>
  </Tabs>
</template>
<script>
export default {
  name: 'TabList',

  props: {
    tabData: Array,
    height: String,
  },

}
</script>
<style lang="less">
  .zpa-tabs {
    display: flex;
    flex-direction: column;

    .ivu-tabs-bar {
      margin-bottom: 8px;
    }

    .ivu-tabs-content {
      flex: 1;
    }

    .ivu-tabs-tabpane {
      display: flex;
      flex-direction: column;
    }
  }
</style>
